import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { ConfirmedChange } from '../domain/confirm-email-change.model';
import type { ConfirmEmailChangeError } from '../domain/confirm-email-change-error';
import { initialState } from './confirm-email-change.state';

/**
 * Confirm-email-change slice. Reducers are pure state transitions only; the POST
 * lives in the saga, which dispatches these as it runs.
 *
 * There is no retry action, on purpose. A failed confirmation is not a transient
 * thing to poke at: the link is invalid, expired, spent, or the address was taken.
 * The only real next step is on the account page, which is where the view points.
 */
const slice = createSlice({
  name: 'confirmEmailChange',
  initialState,
  reducers: {
    confirmStarted: (state) => {
      state.status = 'confirming';
      state.error = null;
    },
    confirmSucceeded: (state, action: PayloadAction<ConfirmedChange>) => {
      state.status = 'confirmed';
      state.confirmed = action.payload;
      state.error = null;
    },
    confirmFailed: (state, action: PayloadAction<ConfirmEmailChangeError>) => {
      state.status = 'failed';
      state.error = action.payload;
    },
    /** Reset on unmount, so a second visit does not open on the last outcome. */
    reset: () => initialState,
  },
});

export const confirmEmailChangeActions = slice.actions;
export const confirmEmailChangeReducer = slice.reducer;
